import { HeaderInfoService } from './../../../servicios/header-info.service';
import { DataLogin } from './../../../servicios/autenticacion.service';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutenticacionService } from 'src/app/servicios/autenticacion.service';
import items from './items';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  public rolUsuario: String;
  public menuOculto: boolean;
  public colorMenu: string = '#c5e345'; // Color por defecto

  constructor(
    private router: Router,
    private readonly location: Location,
    private autenticacionService: AutenticacionService,
    private headerInfoService: HeaderInfoService
  ) { }

  logo: string = 'assets/logos/proptech-white-bg.png';

  itemsMenu: Object[] = items;
  itemSelected: object;

  ngOnInit(): void {
    this.logo = this.headerInfoService.imagenUnidad.value;
    this.headerInfoService.imagenUnidad.subscribe(nuevaImagenUnidad => this.logo = nuevaImagenUnidad);
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));
    this.rolUsuario = loginData.role;
    this.menuOculto = this.headerInfoService.menuOculto.value;
    this.headerInfoService.menuOculto.subscribe(nuevoMenuOculto => this.menuOculto = nuevoMenuOculto);

    // Suscribirse al color dinámico de la compañía
    this.colorMenu = this.headerInfoService.colorCompania.value;
    this.headerInfoService.colorCompania.subscribe(nuevoColor => {
      this.colorMenu = nuevoColor;
    });

    // Llamar a traerDatosPerfil para obtener el color desde el inicio
    this.headerInfoService.traerDatosPerfil().subscribe();

    this.itemsMenu.forEach(item => {
      if (this.location.path().startsWith(item['url'])) {
        this.itemSelected = item;
      } else if(this.location.path() === "") {
        this.itemSelected = items[0];
      }
    })
  }

  onClick(item: object, url: string) {
    this.itemSelected = item;
    this.router.navigate([`${url}`]);
  }

  onCerrarSesion() {
    this.autenticacionService.cerrarSesion();
    this.router.navigate(['login']);
  }

  ajustarColor(color: string, ajuste: number): string {
    // Función para oscurecer el color para el gradiente
    const hex = color.replace('#', '');
    const r = Math.max(0, Math.min(255, parseInt(hex.substr(0, 2), 16) + ajuste));
    const g = Math.max(0, Math.min(255, parseInt(hex.substr(2, 2), 16) + ajuste));
    const b = Math.max(0, Math.min(255, parseInt(hex.substr(4, 2), 16) + ajuste));
    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
  }

}
